import React from 'react';
import styled from 'styled-components';
import { Modal as AntModal, ModalProps as AntModalProps } from 'antd';
import theme from '@config/theme';


interface IModalProps extends AntModalProps {
  width?: number | string;
  title?: React.ReactNode;
}

const ModalComponent = styled(AntModal)`
.ant-modal-header {
  background-color: ${theme.palette.primary[100]};
  border-bottom: 2px solid ${theme.palette.primary.hue};
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  }
.ant-modal-title {
  color: ${theme.palette.primary.hue};
}
.ant-modal-close {
  color: ${theme.palette.primary.hue};
}

.ant-btn {
  border-radius: 8px;
  font-weight: bold;
  & span {
    position: relative;
    bottom: 1px;
  }
}
.ant-btn-primary {
  background-color: ${theme.palette.primary.hue};
  color: ${theme.palette.neutral.white};
  border: 2px solid ${theme.palette.primary.hue};
  &:hover {
    background-color: ${theme.palette.primary.D100};
    border: 2px solid ${theme.palette.primary.D100};
  }
}
.ant-btn-default {
  background-color: ${theme.palette.neutral.white};
  border: 2px solid ${theme.palette.primary.hue};
  color: ${theme.palette.primary.hue};
  &:hover {
    background-color: ${theme.palette.primary.hue};
    border-color: ${theme.palette.primary.hue};
    color: ${theme.palette.neutral.white};
  }
}
.ant-btn-dangerous {
  background-color: ${theme.palette.error.hue} !important;
  border: 2px solid ${theme.palette.error.hue} !important;
  color: ${theme.palette.neutral.white};
  &:hover {
    background-color: ${theme.palette.error.D100};
    border: 2px solid ${theme.palette.error.D100};
  }
`;

const Modal = (props: IModalProps) => {
  return <ModalComponent {...props} />;
};

// Add static methods from AntModal
Modal.confirm = AntModal.confirm;
Modal.info = AntModal.info;
Modal.success = AntModal.success;
Modal.error = AntModal.error;
Modal.warning = AntModal.warning;
Modal.warn = AntModal.warning;
Modal.destroyAll = AntModal.destroyAll;

export default Modal;